import type { RootState } from "../../../Application/globaltypes/redux";
import { createSelector } from "@reduxjs/toolkit";

export const selectContentPacksItems = (state: RootState) => state.licensing.contentPacks.items;
export const selectFlowAssignments = (state: RootState) => state.licensing.contentPacks.flowAssignments;

export const selectContentPacksPackIds = createSelector(
  [selectContentPacksItems, selectFlowAssignments],
  (items, flowAssignments) => [...items.map((i) => i.packId ?? 0), ...flowAssignments.flatMap((item) => item.packIds)],
);
